// In Chrome userAgent string may also include Safari
export const isSafariBrowser = () =>
  window.navigator.userAgent.includes('Safari') &&
  !window.navigator.userAgent.includes('Chrome');

// Safari browser uses 'clientWidth' to define 'width' media feature
export const getBrowserMediaQueryWidth = () => {
  if (isSafariBrowser()) {
    return window.document.body.clientWidth;
  }

  return window.innerWidth;
};
